(function ($) {
	/***********************
	 ******** Video ********
	 ***********************/
	
	 function insertVideo(){
		 this.youtubeElem = null;
	 }

	 RVwys.videoUikit = new insertVideo();
	 
	 
	 //youtube
	 RVwys.videoUikit.youtube = (function(){
		 return {
			 event: function(){
			 	$('.mini_insertYoutube').click(function(event){
			 		RVwys.videoUikit.youtube.openDialog();
			 	});
			 	
			 	$('.editYoutube').click(function(event){
			 		RVwys.videoUikit.youtube.edit();
			 	});
		 	},
		 	openDialog: function(){
		 		$('.warningYoutubeUrlEmpty '+
		 		  ',.warningYoutubeUrlNotValid'+
		 		  ',.warningYoutubeUrlNotValid'+
		 		  ',.warningYoutubeUrlNotValid').hide();
		 		RVwys.uikitDialog("Insert Youtube", $('#contentInsertYoutube').html(), "OK", function(){
		 			var youtubeProperty = {};
		 			
		 			//set regExp validate url
		 			var youtubeUrl = $('.urlYoutube').eq(1).val(),
			 		regExpValidateYoutubeUrl = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/;
			 		
			 		//option youtube
		 			youtubeProperty.URL = youtubeUrl.match(regExpValidateYoutubeUrl);
		 			youtubeProperty.autoplay = $('.autoplay_youtube').eq(1).is(':checked');
		 			youtubeProperty.getShowControll = $('.show_controll').eq(1).is(':checked');
		 			youtubeProperty.getLoop = $('.loop_youtube').eq(1).is(':checked');
		 			youtubeProperty.getWidth = $('.widthYoutube').eq(1).val();
		 			youtubeProperty.getHeight = $('.heightYoutube').eq(1).val();
			 		
			 		if(youtubeUrl == ''){
			 			
			 			$('.warningYoutubeUrlNotValid').hide();
			 			$('.warningYoutubeUrlEmpty').show();
			 			RVwys.warningUiKitDialog = true;
			 			
			 		}else if(youtubeProperty.URL && youtubeProperty.URL[2].length == 11){
	
			 			RVwys.videoUikit.youtube.insert(youtubeProperty);
			 			RVwys.warningUiKitDialog = false;
			 			
			 		}else{
			 			
			 			$('.warningYoutubeUrlEmpty').hide();
			 			$('.warningYoutubeUrlNotValid').show();
			 			RVwys.warningUiKitDialog = true;
			 			
			 		}		
                }, function(){
                    RVwys.warningUiKitDialog = false;
                });
		 	// hide div warningYoutubeUrlEmpty and warningYoutubeUrlNotValid 
		 	},
		 	insert: function(youtubeProperty){
		 		var getObj = RVwys.linkUikit.getSelection(),
		 		getRange = getObj.getRangeAt(0),
		 		//newElement= document.createElement("div"),
		 		//for src param youtube
		 		optionAutoPlay = (youtubeProperty.autoplay)? 'allow="autoplay" autoplay="true"' : 'autoplay="false"',
		 		optionShowControll = (youtubeProperty.getShowControll)? "controls=2" : "controls=0",
		 		optionLoop = (youtubeProperty.getLoop)? "loop=1&playlist="+youtubeProperty.URL[2] : "loop=0";
		 		optionLoop += (youtubeProperty.autoplay)? "&autoplay=1": "&autoplay=0";
		 		//for attr youtube
		 		var attrShowControll = (youtubeProperty.getShowControll)? 'controls="true"' : 'controls="false"',
		 		attrLoop = (youtubeProperty.getLoop)? 'loop="true"' : 'loop="false"';
		 		
		 		//$(newElement).addClass('video_youtube dtbarvideo').attr({
		 		//	'id': youtubeProperty.URL[2],
		 		//	'contenteditable':'false'
		 		//	}); 
		 		var youtubeframe = '<iframe class="iframeYoutube" width="'+youtubeProperty.getWidth+'" '+optionAutoPlay+' '+attrShowControll+' '+attrLoop+' height="'+youtubeProperty.getHeight+'" src="https://www.youtube.com/embed/'+youtubeProperty.URL[2]+'?enablejsapi=1&version=3&'+optionShowControll+'&'+optionLoop+'" style="max-width:100%; min-height:100px;"></iframe>';
		 			//alert(youtubeProperty.URL[2])
		 		var imgYoutube = $('<img ' 
		 				+'id="'+youtubeProperty.URL[2]+'" '
		 				+'class="video_youtube" '
		 				+'src="'+ parent.wex.url.WYS_IMG_URL+'images/thumb-vdo.jpg"'
		 				+'width="'+youtubeProperty.getWidth+'" '
		 				+'height="'+youtubeProperty.getHeight+'"'
		 				+optionAutoPlay+' '+attrShowControll+' '+attrLoop
		 				+'srcyoutube="https://www.youtube.com/embed/'+youtubeProperty.URL[2]+'?enablejsapi=1&version=3&'+optionShowControll+'&'+optionLoop+'"' 
		 				+'cmdPreviewWys="'+btoa(youtubeframe)+'"'
		 				+'style=" max-width:100%; height:auto" />');
		 		RVwys.insertHTML(imgYoutube);
		 		getObj.removeAllRanges();
		 		var sel = RVwys.currentEditor.getSelection();
		 		var range = RVwys.currentEditor.createRange();
                var fb = $('#frameBody').get(0).contentWindow;
                getObj.addRange(range);
                range.selectNode(fb.$('#'+youtubeProperty.URL[2]).get(0));
                $(RVwys.currentiFrame).focus();
		 		//$(newElement).append('<iframe class="iframeYoutube" width="'+youtubeProperty.getWidth+'" '+optionAutoPlay+' '+attrShowControll+' '+attrLoop+' height="'+youtubeProperty.getHeight+'" src="https://www.youtube.com/embed/'+youtubeProperty.URL[2]+'?enablejsapi=1&version=3&'+optionShowControll+'&'+optionLoop+'" style="pointer-events: none; max-width:100%; min-height:250px;"></iframe>');
		 		//getRange.insertNode(newElement);
	            //getObj.removeAllRanges();
	            
	            //clear youtube property
	            youtubeProperty = null;
		 	},
		 	detectClickWys: function(elemTarget){
		 		var isVideo = ($(elemTarget).hasClass("video_youtube"))?true:false;
		 		//alert(elemTarget.tagName)
		 		parent.$('.editYoutubeEmbed').toggle(isVideo);
		 		parent.$('#dynamictoolbar_insert').toggle(!isVideo);

		 		if(isVideo){
		 			var sel = RVwys.currentEditor.getSelection();    
		    		 parent.RVwys.videoUikit.youtube.elem = $(elemTarget);
		    		 console.log("Check in");
		    		 console.log(parent.RVwys.videoUikit.youtube.elem);
                     sel.removeAllRanges();
                     var newSel = RVwys.currentEditor.createRange();
                     newSel.selectNode(elemTarget);
                     sel.addRange(newSel);
		    	 }else{
		    		 parent.RVwys.videoUikit.youtube.elem = null;
		    		 console.log("Check out");
		    		 console.log(parent.RVwys.videoUikit.youtube.elem);
		    	 }
		 	},
		 	edit: function(){
		 		$('.warningYoutubeUrlEmpty '+
				 		  ',.warningYoutubeUrlNotValid'+
				 		  ',.warningYoutubeUrlNotValid'+
				 		  ',.warningYoutubeUrlNotValid').hide();
		 		var getYoutubeElem = parent.RVwys.videoUikit.youtube.elem;
		 		//alert(getYoutubeElem.get(0).tagName)
		 		setTimeout(function(){
		 				
		 			$('.urlYoutube').eq(1).val("https://www.youtube.com/watch?v="+getYoutubeElem.attr("id"));
		 			$('.widthYoutube').eq(1).val(getYoutubeElem.attr("width"));
		 			$('.heightYoutube').eq(1).val(getYoutubeElem.attr("height"));
		 			
		 			if(getYoutubeElem.get(0).getAttribute("autoplay") == 'true')  $('.autoplay_youtube').eq(1).prop( "checked", true );
		 			if(getYoutubeElem.get(0).getAttribute("loop") == 'true')  $('.loop_youtube').eq(1).prop( "checked", true );
		 			if(getYoutubeElem.get(0).getAttribute("controls") == 'true')  $('.show_controll').eq(1).prop( "checked", true );

                }, 100);
		 		
				RVwys.uikitDialog("Edit Youtube", $('#contentInsertYoutube').html(), "OK", function(){
					var youtubeProperty = {};

					//set regExp validate url
					var youtubeUrl = $('.urlYoutube').eq(1).val(),
					regExpValidateYoutubeUrl = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/;
					
					//option youtube
					youtubeProperty.URL = youtubeUrl.match(regExpValidateYoutubeUrl);
					youtubeProperty.autoplay = $('.autoplay_youtube').eq(1).is(':checked');
					youtubeProperty.getShowControll = $('.show_controll').eq(1).is(':checked');
					youtubeProperty.getLoop = $('.loop_youtube').eq(1).is(':checked');
					youtubeProperty.getWidth = $('.widthYoutube').eq(1).val();
					youtubeProperty.getHeight = $('.heightYoutube').eq(1).val();
					
					if(youtubeUrl == ''){
						
						$('.warningYoutubeUrlNotValid').hide();
						$('.warningYoutubeUrlEmpty').show();
						RVwys.warningUiKitDialog = true;
						
					}else if(youtubeProperty.URL && youtubeProperty.URL[2].length == 11){
						
						//for src param youtube & attr youtube
				 		var optionAutoPlay = (youtubeProperty.autoplay)? 'allow="autoplay" autoplay="true"' : 'autoplay="false"',
				 		optionShowControll = (youtubeProperty.getShowControll)? "controls=2" : "controls=0",
				 		optionLoop = (youtubeProperty.getLoop)? "loop=1&playlist="+youtubeProperty.URL[2] : "loop=0",
				 		attrShowControll = (youtubeProperty.getShowControll)? 'controls="true"' : 'controls="false"',
				 		attrLoop = (youtubeProperty.getLoop)? 'loop="true"' : 'loop="false"';
				 		optionLoop += (youtubeProperty.autoplay)? "&autoplay=1": "&autoplay=0";
				 		//set elem attributes from setting
						getYoutubeElem.attr('id', youtubeProperty.URL[2]);
				 		
				 		getYoutubeElem.attr({srcyoutube : "https://www.youtube.com/embed/"+youtubeProperty.URL[2]+"?enablejsapi=1&version=3&"+optionShowControll+"&"+optionLoop, width : youtubeProperty.getWidth, height :  youtubeProperty.getHeight });				 		
						getYoutubeElem.get(0).setAttribute("autoplay", (youtubeProperty.autoplay)? 'true' : 'false');
						getYoutubeElem.get(0).setAttribute("loop", (youtubeProperty.getLoop)? 'true' : 'false');
						getYoutubeElem.get(0).setAttribute("controls", (youtubeProperty.getShowControll)? 'true' : 'false');
						var youtubeframe = '<iframe class="iframeYoutube" width="'+youtubeProperty.getWidth+'" '+optionAutoPlay+' '+attrShowControll+' '+attrLoop+' height="'+youtubeProperty.getHeight+'" src="https://www.youtube.com/embed/'+youtubeProperty.URL[2]+'?enablejsapi=1&version=3&'+optionShowControll+'&'+optionLoop+'" style="max-width:100%; min-height:250px;"></iframe>';

						getYoutubeElem.get(0).setAttribute("cmdpreviewwys",  btoa(youtubeframe));
						
						
						//clear youtube property
						youtubeProperty = null;
						
						RVwys.warningUiKitDialog = false;
					}else{
						
						$('.warningYoutubeUrlEmpty').hide();
						$('.warningYoutubeUrlNotValid').show();
						RVwys.warningUiKitDialog = true;
						
					}		
					}, function(){
					    RVwys.warningUiKitDialog = false;
					});
		 	}
		 };
	 }());
	 
	 //vimeo

	 RVwys.videoUikit.vimeo = (function(){
		 
		 return {
			 event: function(){

			 	$('.mini_insertVimeo').click(function(event){
			 		RVwys.videoUikit.vimeo.openDialog();
			 	});
		 	},
		 	openDialog: function(){
		 		$('.warningYoutubeUrlEmpty '+
				 		  ',.warningYoutubeUrlNotValid'+
				 		  ',.warningYoutubeUrlNotValid'+
				 		  ',.warningYoutubeUrlNotValid').hide();
				RVwys.uikitDialog("Insert Vimeo", $('#contentInsertVimeo').html(), "OK", function(){
					var vimeoProperty = {};
					
					//set regExp validate url
					var youtubeUrl = $('.urlYoutube').eq(1).val(),
					regExpValidateYoutubeUrl = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/;

					//option youtube
					vimeoProperty.URL = youtubeUrl.match(regExpValidateYoutubeUrl);
					vimeoProperty.autoplay = $('.autoplay_youtube').eq(1).is(':checked');
					vimeoProperty.getShowControll = $('.show_controll').eq(1).is(':checked');
					vimeoProperty.getLoop = $('.loop_youtube').eq(1).is(':checked');
					vimeoProperty.getWidth = $('.widthYoutube').eq(1).val();
					vimeoProperty.getHeight = $('.heightYoutube').eq(1).val();
					
					if(youtubeUrl == ''){
						
						$('.warningYoutubeUrlNotValid').hide();
						$('.warningYoutubeUrlEmpty').show();
						RVwys.warningUiKitDialog = true;
						
					}else if(vimeoProperty.URL && vimeoProperty.URL[2].length == 11){
				
						RVwys.videoUikit.youtube.insert(vimeoProperty);
						
						RVwys.warningUiKitDialog = false;
						
					}else{
						$('.warningYoutubeUrlEmpty').hide();
						$('.warningYoutubeUrlNotValid').show();
						RVwys.warningUiKitDialog = true;
						
					}		
				}, function(){
					RVwys.warningUiKitDialog = false;
				});

		 	}
		 };

	 }());
	
	 
	 $(document).bind('editorReady',function(){
        //event youtube
        RVwys.videoUikit.youtube.event();
        
        //event vimeo
        RVwys.videoUikit.vimeo.event();
     });
	 
     RVwys.designViewAddEvent('mousedown',function(e){
    	 //detect youtube iframe onclick wys
    	 parent.RVwys.videoUikit.youtube.detectClickWys(e.target);
  
     });
     $(document).bind('editorClose',function() {
    	 
     });
})(jQuery);